export default __webpack_public_path__ + "static/media/Swift@2x.f789baf3.png";